import type { FC } from 'react';
import { VideoTutorialsWrapper } from './VideoTutorials.styled';
import sourceCode from './../../resources/videoTutorial/source-code.png';
import playSubscribe from './../../resources/videoTutorial/play-subscribe.png';
import EmbedYoutube from '../utils/EmbedYoutube/EmbedYoutube';

interface VideoTutorialsProps { }

const VideoTutorials: FC<VideoTutorialsProps> = () => (
   <VideoTutorialsWrapper>
      <header className="entry-header">
         <h1 className="entry-title" itemProp="headline">
            Java Tutorial Playlist – Learn Java Programming Step by Step In Detail
         </h1>
         <br/>
      </header>
      <div className="entry-content clear" itemProp="text">
         <br />
         <h2 className="has-text-align-center has-text-color has-link-color" style={{ color: '#647f19' }}>
            <strong><em>JAVA BASICS FROM SCRATCH</em></strong>
         </h2>
         <div className="epyt-gallery" data-currpage="1">
            <EmbedYoutube videoType="video" videoList={["tORJqGGNAhA"]} />
            <div className="epyt-gallery-subscribe">
               <a className="epyt-gallery-subbutton" href="https://youtube.com/channel/UCpIueiXyq5nhTJTDuw2DQnA?sub_confirmation=1">
                  <img className="lazy-loaded" decoding="async" alt="subscribe" src={playSubscribe} data-lazy-type="image" />
                  Subscribe
               </a>
            </div>
         </div>

         <hr />
         <br />
         <EmbedYoutube videoType="playlist" videoList={["tORJqGGNAhA","Vz6k8xRaABA","jKK84ugldpE", "rcHjnnUKdXQ", "dYGJIJdGgEQ", "RqvmcoXcoLM", "to3c3m5jfKU"]} />
         <br/>

         <div className="has-huge-padding">
            <div className="source-code" style={{ maxWidth: '835px' }}>
               <figure className="has-shadow">
                  <img decoding="async" width="1024" height="1024" src={sourceCode} data-lazy-type="image" alt="" className="lazy-loaded" sizes="auto, (max-width: 1024px) 100vw, 1024px" />
               </figure>
               <div className="source-code-div has-shadow">
                  <div className="source-code-inner has-background has-padding has-huge-padding has-no-margin is-stacked-on-mobile has-medium-gutter" style={{ backgroundColor: '#FFFFFF' }}>
                     <div className="has-no-padding has-no-margin">
                        <h3>Source Code</h3>
                        <p>
                           To download the source code, visit – 
                           <a href="https://github.com/misstechack/Java-Tutorial/" style={{color: '#647f19'}} target="_blank" rel="noreferrer noopener">https://github.com/misstechack/Java-Tutorial/</a>
                        </p>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <hr />
         <br />
         <h2 className="has-text-align-center has-text-color has-link-color" style={{ color: '#647f19' }}>
            <strong><em>PROGRAMMING FUNDAMENTALS</em></strong>
         </h2>
         
         <div className="epyt-gallery" data-currpage="1">
            <EmbedYoutube videoType="video" videoList={["wMAEa2U_03k"]} />
            <div className="epyt-gallery-subscribe">
               <a className="epyt-gallery-subbutton" href="https://youtube.com/channel/UCpIueiXyq5nhTJTDuw2DQnA?sub_confirmation=1">
                  <img className="lazy-loaded" decoding="async" alt="subscribe" src={playSubscribe} data-lazy-type="image" />
                  Subscribe
               </a>
            </div>
         </div>

         <hr />
         <br />
         <EmbedYoutube videoType="playlist" videoList={["wMAEa2U_03k","Q5MnyFfpbls","EjoWkBttAWE","7KixECa4CPM","HQWyn3Yf33k","KkysGYu_YIU","UQ9JOV9z6ko"]} />
         <br/>
         <hr />
         <br />
         <h2 className="has-text-align-center has-text-color has-link-color" style={{ color: '#647f19' }}>
            <strong><em>JAVA INTERVIEW QUESTIONS</em></strong>
         </h2>
         
         <div className="epyt-gallery" data-currpage="1">
         <EmbedYoutube videoType="video" videoList={["IQdr_2Aww8Q"]} />
            <div className="epyt-gallery-subscribe">
               <a className="epyt-gallery-subbutton" href="https://youtube.com/channel/UCpIueiXyq5nhTJTDuw2DQnA?sub_confirmation=1">
                  <img className="lazy-loaded" decoding="async" alt="subscribe" src={playSubscribe} data-lazy-type="image" />
                  Subscribe
               </a>
            </div>
         </div>
         
         <hr />
         <br />
         <EmbedYoutube videoType="playlist" videoList={["BcQPtriMT5g","XWYlD7ggAm4","H-vlibubUuI","NfjdepN9eXg","1rNYHJIT3Jo","QP4_jQK1cNo","o_9C3cgmf_Q"]} />
         <br/>

         <hr />
         <br />
         <h2 className="has-text-align-center has-text-color has-link-color" style={{ color: '#647f19' }}>
            <strong><em>DYNAMIC PROGRAMMING</em></strong>
         </h2>
         <div className="epyt-gallery" data-currpage="1">
         <EmbedYoutube videoType="video" videoList={["Xp32RagPLgk"]} />
            <div className="epyt-gallery-subscribe">
               <a className="epyt-gallery-subbutton" href="https://youtube.com/channel/UCpIueiXyq5nhTJTDuw2DQnA?sub_confirmation=1">
                  <img className="lazy-loaded" decoding="async" alt="subscribe" src={playSubscribe} data-lazy-type="image" />
                  Subscribe
               </a>
            </div>
         </div>
         
      </div>
   </VideoTutorialsWrapper>
);

export default VideoTutorials;
